import React from 'react';
import { ConfigProvider } from 'antd';
import ApiDocs from './components/ApiDocs';
import './styles/main.scss';

const App = () => {
  return (
    <ConfigProvider
      theme={{
        token: {
          colorPrimary: '#635bff',
        },
      }}
    >
      <ApiDocs />
    </ConfigProvider>
  );
};

export default App; 